import {memo} from 'react'
import './Input.css'

function InputComponent(props) {
	return (
		<input
			value={props.value}
			onChange={props.onChange}
			onClick={props.onClick}
			type={props.type} 
			className="input"
			required={props?.required === false ? props?.required : true}
			style={{borderColor: props.borderColor}}
			placeholder={props.placeholder}
			maxLength={props?.maxLength ? props?.maxLength : '64'}
			readOnly={props?.readOnly}
			pattern={props?.pattern}
			name={props?.name}
		/>
	)
}

export const Input = memo(InputComponent)